<template>
  <Layout>
    <v-container
      slot="content"
      :class="$vuetify.breakpoint.width < 960 ? 'mb-6 mt-0' : 'mb-6 mt-0'"
      :style="
        $vuetify.breakpoint.width < 960
          ? 'max-width: 98%'
          : $store.getters.selectedWsInfo
          ? 'max-width: calc(100% - 50px)'
          : 'max-width: 85%'
      "
    >
      <ChannelHeader v-if="$route.name !== 'Assigned' && !isMeetingListLoading"></ChannelHeader>
      <!-- <AddTemplate
        v-if="
          $route.name !== 'Assigned' &&
          selectedCh['chCategory'] !== 'inbox' &&
          !isMeetingListLoading &&
          $store.getters.selectedWsInfo
        "
        @startMeeting="startMeeting($event)"
        :isStartMeetingLoading.sync="isStartMeetingLoading"
        :startMeetingEvent.sync="startMeetingEvent"
      ></AddTemplate> -->
      <!-- inbox -->
      <v-row v-if="selectedCh['chCategory'] === 'inbox'" no-gutters justify="center" align="center">
        <!-- inbox 비어있음 -->
        <v-col
          v-if="
            isEmpty && $store.getters.selectedWsInfo && userInfo && userInfo['userId'] === selectedCh['chPermission']
          "
          cols="12"
          class="container-inbox-title-sub my-2"
          :style="
            $vuetify.breakpoint.width < 960
              ? 'text-align: center; padding-left: 0px; font-size: 13px'
              : 'padding-left: 0px'
          "
        >
          <span class="assigned-sub-title">
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style="display: inline-block"
            >
              <path
                d="M24.1669 18.5724H8.21115C6.44052 18.5724 5 20.0024 5 21.7824V26.7324C5 28.5024 6.44052 29.9424 8.21115 29.9424H24.1669C25.9375 29.9424 27.378 28.5024 27.378 26.7324V21.7824C27.368 20.0024 25.9375 18.5724 24.1669 18.5724Z"
                fill="#9B9B9B"
              />
              <path
                d="M24.15 9.13245H8.21C6.44 9.13245 5 10.5724 5 12.3424V22.6724C5 24.4424 6.44 25.8824 8.21 25.8824H11.56C11.81 25.8824 12.05 26.0024 12.19 26.2024C13.07 27.4624 14.53 28.2924 16.19 28.2924C17.85 28.2924 19.31 27.4624 20.19 26.2024C20.33 26.0024 20.57 25.8824 20.82 25.8824H24.17C25.94 25.8824 27.38 24.4424 27.38 22.6724V12.3424C27.36 10.5724 25.93 9.13245 24.15 9.13245Z"
                fill="#E6E6E6"
              />
              <path
                d="M22.32 11.6825H10.04C8.68001 11.6825 7.57001 12.7925 7.57001 14.1525V20.9625C7.57001 22.3225 8.68001 23.4325 10.04 23.4325H13.12C13.48 23.4325 13.78 23.6825 13.87 24.0325C14.14 25.0625 15.07 25.8225 16.18 25.8225C17.29 25.8225 18.23 25.0625 18.49 24.0325C18.58 23.6825 18.88 23.4325 19.24 23.4325H22.32C23.68 23.4325 24.79 22.3225 24.79 20.9625V14.1525C24.79 12.7925 23.69 11.6825 22.32 11.6825Z"
                fill="#00A6ED"
              />
              <path
                d="M18.94 3.47001V10.57C18.94 10.73 19.07 10.85 19.22 10.85H20.2C20.82 10.85 21.15 11.59 20.73 12.05L16.72 16.46C16.44 16.77 15.95 16.77 15.66 16.46L11.64 12.05C11.22 11.59 11.55 10.85 12.17 10.85H13.15C13.31 10.85 13.43 10.72 13.43 10.57V3.47001C13.43 3.21001 13.64 3.00001 13.9 3.00001H18.48C18.73 3.00001 18.94 3.21001 18.94 3.47001Z"
                fill="#F92F60"
              />
            </svg>
            {{ $t('inboxEmpty') }}
          </span>
          <v-col
            class="mt-4 px-10 py-8 empty-desc-box"
            cols="auto"
            style="background-color: #425258; display: inline-block; text-align: left; border-radius: 25px"
          >
            <v-row>
              <v-col>
                <span style="color: #eee">
                  Share the link to this page and let people submit video messages to you.
                </span>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <span
                  class="font-weight-bold pointer"
                  style="color: #40dc9d; text-decoration: underline"
                  @click="copyUrlToClipboard"
                >
                  Copy Link to Your Inbox
                </span>
              </v-col>
            </v-row>
          </v-col>
        </v-col>
        <!-- inbox 외부접근 -->
        <v-row
          v-if="isEmpty && (!$store.getters.selectedWsInfo || !userInfo)"
          class="text-center"
          :style="isMobile ? 'text-align: center; padding-left: 0px' : 'padding-left: 0px; margin-top: 100px'"
        >
          <v-col cols="12">
            <span class="inbox-sub-title">
              {{ '📼 Send a video message' }}
            </span>
          </v-col>
          <v-col cols="12" style="margin-top: -12px">
            <span class="inbox-sub-desc font-weight-light" style="color: rgba(255, 255, 255, 0.8)">
              {{ 'Click the button below to start' }}
            </span>
          </v-col>
        </v-row>
        <!-- 외부접근인데 권한 없음 -->
        <!-- <v-row
        v-if="$route.name === 'Inbox'"
        class="container-inbox-title-sub my-2 text-center"
        :style="isMobile ? 'text-align: center; padding-left: 0px' : 'padding-left: 25px'"
        no-gutters
      >
        <v-col cols="12" style="text-align: center">
          <router-link to="/" class="inbox-sub-title">
            <h1 class="logo" style="display: inline-block; width: auto"></h1>
          </router-link>
        </v-col>

        <v-col cols="12">
          <span class="inbox-sub-title text-h6 font-weight-light" style="color: rgba(255, 255, 255, 0.8)">
            {{ 'This link is currently disabled. ️🙁' }}
          </span>
        </v-col>
        <v-col cols="12">
          <span class="inbox-sub-title text-h6 font-weight-light" style="color: rgba(255, 255, 255, 0.8)">
            {{ 'Please contact the owner and ask enable it again.' }}
          </span>
        </v-col>
      </v-row> -->
        <!-- 미팅 리스트 -->
        <v-row row wrap class="list-container" v-else :justify="'center'">
          <v-col v-if="!isMeetingListLoading" cols="auto" style="padding-bottom: 12px">
            <new-meeting-card
              @startMeeting="startMeeting($event)"
              :isStartMeetingLoading.sync="isStartMeetingLoading"
              :startMeetingEvent.sync="startMeetingEvent"
            ></new-meeting-card>
          </v-col>
          <!-- TODO:// -->
          <v-col cols="auto" v-for="meeting in meetingList" :key="meeting.mtId">
            <!-- <v-col cols="auto" v-for="meeting in meetingList" :key="meeting.mtId" :style="$vuetify.breakpoint.width < 960 ? 'padding: 15px 0 15px 0' : 'padding: 12px 0 12px 12px'"> -->
            <list-card-item :cardType="'grid'" :cardItem="meeting" @result="deleteResult" />
          </v-col>
        </v-row>
      </v-row>
      <!-- assigned -->
      <v-row v-else-if="$route.name === 'Assigned' && !isEmpty" no-gutters justify="center" align="center">
        <v-col cols="12" class="container-assigned-title-sub mt-2 mb-4">
          <span :class="$vuetify.breakpoint.width < 570 ? 'assigned-sub-title' : 'assigned-sub-title ml-4'">
            {{ $t('assignedSubTitle') }}
          </span>
        </v-col>
        <!-- assigned 미팅 리스트 -->
        <v-row row wrap class="list-container" v-if="!isEmpty" :justify="'center'">
          <v-col
            cols="auto"
            v-for="meeting in meetingList"
            :key="meeting.mtId"
            :style="$vuetify.breakpoint.width < 960 ? 'padding: 15px 0 15px 0' : 'padding: 12px 0 12px 12px'"
          >
            <list-card-item :cardType="'grid'" :cardItem="meeting" @result="deleteResult" />
          </v-col>
        </v-row>
      </v-row>
      <!-- 일반 채널 -->
      <v-row
        v-else-if="selectedCh['chCategory'] !== 'inbox' && $route.name !== 'Assign' && !isEmpty"
        row
        wrap
        class="list-container"
        :justify="'center'"
      >
        <v-col v-if="!isMeetingListLoading" cols="auto" style="padding-bottom: 12px">
          <new-meeting-card
            @startMeeting="startMeeting($event)"
            :isStartMeetingLoading.sync="isStartMeetingLoading"
            :startMeetingEvent.sync="startMeetingEvent"
          ></new-meeting-card>
        </v-col>
        <!-- 채널 미팅 리스트 -->
        <!-- TODO:// -->
        <!-- <v-col
          cols="auto"
          v-for="meeting in meetingList"
          :key="meeting.mtId"
          :style="$vuetify.breakpoint.width < 960 ? 'padding: 15px 0 15px 0' : 'padding: 12px 0 12px 12px'"
        > -->
        <v-col cols="auto" v-for="meeting in meetingList" :key="meeting.mtId" style="padding-bottom: 12px">
          <list-card-item :cardType="'grid'" :cardItem="meeting" @result="deleteResult" />
        </v-col>
      </v-row>
      <v-row
        v-else-if="isEmpty && (!$store.getters.selectedWsInfo || !userInfo)"
        class="text-center"
        :style="isMobile ? 'text-align: center; padding-left: 0px' : 'padding-left: 0px; margin-top: 100px'"
      >
        <v-col cols="12">
          <span class="inbox-sub-title">
            {{ '📼 Send a video message' }}
          </span>
        </v-col>
        <v-col cols="12" style="margin-top: -12px">
          <span class="inbox-sub-desc font-weight-light" style="color: rgba(255, 255, 255, 0.8)">
            {{ 'Click the button below to start' }}
          </span>
        </v-col>
      </v-row>
      <empty
        v-else
        @startMeeting="startMeeting($event)"
        :isStartMeetingLoading.sync="isStartMeetingLoading"
        :startMeetingEvent.sync="startMeetingEvent"
      ></empty>

      <!-- <v-row v-if="$route.name !== 'Assigned' && isMeetingListLoading">
        <v-col class="text-center py-16 mt-8 mb-16">
          <v-progress-circular color="primary" size="50" indeterminate class="mb-16" />
        </v-col>
      </v-row> -->

      <v-row :justify="'center'" v-if="$route.name !== 'Assigned' && isMeetingListLoading && !additionalLoading">
        <v-skeleton-loader
          dark
          type="card-heading, list-item-two-line"
          width="100%"
          :class="$vuetify.breakpoint.width < 570 ? 'mx-3 mb-8 skeleton-header' : 'mt-3 mb-6 skeleton-header'"
          style="border-radius: 10px !important"
        ></v-skeleton-loader>
      </v-row>
      <!-- <v-row
        :justify="'center'"
        v-if="
          $route.name !== 'Assigned' &&
          selectedCh['chCategory'] !== 'inbox' &&
          isMeetingListLoading &&
          !additionalLoading &&
          $store.getters.selectedWsInfo
        "
      >
        <v-skeleton-loader
          dark
          type="actions"
          width="100%"
          :height="$vuetify.breakpoint.width < 960 ? '30px' : '30px'"
          :class="$vuetify.breakpoint.width < 960 ? 'mx-3 mb-5 skeleton-header' : 'mb-5 skeleton-header'"
          :style="
            $vuetify.breakpoint.width < 960
              ? 'border-radius: 10px !important; overflow: hidden; padding: 0px !important'
              : 'border-radius: 10px !important; overflow: hidden'
          "
        ></v-skeleton-loader>
      </v-row> -->

      <!-- 미팅 리스트 스켈레톤 로딩 -->
      <v-row wrap class="list-container" :justify="'center'" v-if="isMeetingListLoading">
        <v-skeleton-loader
          dark
          type="card-avatar, list-item-three-line"
          :width="$vuetify.breakpoint.width < 570 ? '95%' : '250px'"
          height="350px"
          :class="$vuetify.breakpoint.width < 555 ? 'ma-2' : 'ma-3'"
        ></v-skeleton-loader>
        <v-skeleton-loader
          dark
          type="card-avatar, list-item-three-line"
          :width="$vuetify.breakpoint.width < 570 ? '95%' : '250px'"
          height="350px"
          :class="$vuetify.breakpoint.width < 555 ? 'ma-2' : 'ma-3'"
        ></v-skeleton-loader>
        <v-skeleton-loader
          dark
          type="card-avatar, list-item-three-line"
          :width="$vuetify.breakpoint.width < 570 ? '95%' : '250px'"
          height="350px"
          :class="$vuetify.breakpoint.width < 555 ? 'ma-2' : 'ma-3'"
        ></v-skeleton-loader>
        <v-skeleton-loader
          dark
          type="card-avatar, list-item-three-line"
          :width="$vuetify.breakpoint.width < 570 ? '95%' : '250px'"
          height="350px"
          :class="$vuetify.breakpoint.width < 555 ? 'ma-2' : 'ma-3'"
        ></v-skeleton-loader>
        <v-skeleton-loader
          dark
          type="card-avatar, list-item-three-line"
          :width="$vuetify.breakpoint.width < 570 ? '95%' : '250px'"
          height="350px"
          :class="$vuetify.breakpoint.width < 555 ? 'ma-2' : 'ma-3'"
        ></v-skeleton-loader>
        <v-skeleton-loader
          dark
          type="card-avatar, list-item-three-line"
          :width="$vuetify.breakpoint.width < 570 ? '95%' : '250px'"
          height="350px"
          :class="$vuetify.breakpoint.width < 555 ? 'ma-2' : 'ma-3'"
        ></v-skeleton-loader>
        <v-skeleton-loader
          dark
          type="card-avatar, list-item-three-line"
          :width="$vuetify.breakpoint.width < 570 ? '95%' : '250px'"
          height="350px"
          :class="$vuetify.breakpoint.width < 555 ? 'ma-2' : 'ma-3'"
        ></v-skeleton-loader>
        <v-skeleton-loader
          dark
          type="card-avatar, list-item-three-line"
          :width="$vuetify.breakpoint.width < 570 ? '95%' : '250px'"
          height="350px"
          :class="$vuetify.breakpoint.width < 555 ? 'ma-2' : 'ma-3'"
        ></v-skeleton-loader>
      </v-row>

      <!-- 미팅 스타트 버튼 -->
      <v-container
        fluid
        class="floating-layout"
        v-if="
          (selectedCh.chCategory == 'inbox' &&
            (!userInfo || (userInfo && selectedCh.chPermission !== userInfo.userId))) ||
          selectedCh.chCategory !== 'inbox'
        "
        :style="isShowSidebar ? 'left: 280px; transition: all 0.3s' : 'left: 0px; transition: all 0.3s'"
      >
        <v-row v-if="!$store.getters.selectedWsInfo" class="floating-menu" align="center" justify="center">
          <v-btn
            :loading="isStartMeetingLoading"
            class="start-meeting"
            width="350"
            height="55"
            @click="startMeeting"
            color="rgb(40, 144, 103)"
            :disabled="selectedCh['chCategory'] === 'inbox' && selectedCh.receivingStatus !== 'on'"
          >
            <span style="font-size: 16px; font-weight: 600">
              {{ $store.getters.selectedWsInfo ? $t('startMeeting') : $t('startConversation') }}
            </span>
          </v-btn>
        </v-row>
      </v-container>

      <guest-in v-if="guestInVisible" @close="closeGuestIn" :guestInVisible.sync="guestInVisible"></guest-in>
    </v-container>

    <!-- <v-container slot="content" fluid fill-height v-else-if="meetingList.length === 0 && isMeetingListLoading">
      <v-row>
        <v-col class="text-center">
          <v-progress-circular color="primary" size="50" indeterminate class="mb-16" />
        </v-col>
      </v-row>
    </v-container> -->
  </Layout>
</template>
<script>
import Layout from '@/views/Meeting'
import ListCardItem from '@/views/meeting/component/ListCardItem'
import NewMeetingCard from '@/views/meeting/component/NewMeetingCard'
import { getMtInfo, setCreateMt, getPublicInboxList } from '@/services/meetingApi'
import { getChannelMt } from '@/services/channelApi'
import ChannelHeader from '@/views/workspace/component/channelHeader'
// import AddTemplate from '@/views/workspace/component/AddTemplate'
import Empty from '@/views/meeting/component/Empty'
import { isMobile } from '@/common/lib/strLib'
import { mapGetters } from 'vuex'
import GuestIn from '@/views/modal/GuestIn'
import { copy } from '@/common/common'
import { getShareUrl, setUserFunnel } from '@/services/api'
import value from '@/common/value'
import Toast from '@/views/meeting/component/Toast'

export default {
  components: { ListCardItem, Layout, Empty, GuestIn, ChannelHeader, NewMeetingCard },
  created() {
    this.$store.dispatch('setFirebaseLog', {
      eventName: 'screen_view',
      eventParam: {
        firebase_screen: '미팅 리스트 조회',
        firebase_screen_class: 'List',
      },
    })
    // Inbox Channel 외부 접근인 경우
    if (this.isInboxAccess) {
      this.$store.dispatch('setFirebaseLog', {
        eventName: 'inbox_access',
        eventParam: {
          name: 'inbox_access',
        },
      })
    }
    window.addEventListener('scroll', this.bottomCheck)

    document.title = 'Tape - AI-Powered Recording, Transcription, and Summarization'
  },
  mounted() {
    // 외부에서 접근했을 경우에만 호출, 그 외에는 watched 에서 채널이 로드된 이후 호출
    if (this.isChListLoaded) this.getMtList()
    this.$nextTick(() => {
      this.headerWidth()
      window.addEventListener('resize', this.headerWidth)
    })
    // console.log(this.$route)
  },
  updated() {
    this.$nextTick(() => {
      this.headerWidth()
    })
  },
  beforeDestroy() {
    this.meetingList = []
    window.removeEventListener('scroll', this.bottomCheck)
    window.removeEventListener('resize', this.headerWidth)
  },
  data: () => ({
    isEmpty: false,
    dialogFormVisible: false,
    isBottom: false,
    meetingList: [],
    isFinish: false,
    index: 0,
    page: 1,
    pageLimit: 20,
    mtIdList: null,
    cards: ['Today', 'Yesterday'],
    selection: 1,
    wsLogo: '',
    alignments: ['start', ''],
    isStartMeetingLoading: false,
    startMeetingEvent: null,
    isMeetingListLoading: true,
    isMeetingListLoaded: false,
    guestInVisible: false,
    additionalLoading: false,
  }),
  computed: {
    ...mapGetters([
      'assignedInfo',
      'selectedWsInfo',
      'userInfo',
      'userName',
      'chList',
      'selectedCh',
      'isChListLoaded',
      'chkChPublic',
      'wsClipCnt',
    ]),
    isMobile() {
      return isMobile()
    },
    isShowSidebar() {
      if (!this.selectedWsInfo) {
        return false
      }
      return this.$store.getters.drawer
    },
    isInboxAccess() {
      return (
        this.selectedCh &&
        this.selectedCh['chCategory'] === 'inbox' &&
        (!this.userInfo || this.userInfo['userId'] !== this.selectedCh['chPermission'])
      )
    },
  },
  watch: {
    $route(to) {
      this.isMeetingListLoaded = false
      if (to.name === 'Assigned') {
        this.page = 1
        this.meetingList = []
        this.isFinish = false
        this.isEmpty = false
        this.getAssignedMtIdList()
      } else if (this.chkChPublic && this.chkChPublic['isPublic']) {
        // } else if (this.selectedCh['chCategory'] === 'inbox') {
        this.page = 1
        this.meetingList = []
        this.isFinish = false
        this.isEmpty = false
        this.getInboxMtInfo()
      } else if (to.name === 'Channel') {
        this.page = 1
        this.meetingList = []
        this.isFinish = false
        this.isEmpty = false
        this.getChannelMtList()
      }
    },
    chList: {
      immediate: true,
      deep: true,
      handler(newList, oldList) {
        if (!oldList && this.$route && this.$route.params['chId'] === 'my') this.moveRoute(newList)
      },
    },
    isChListLoaded() {
      this.getMtList()
    },
    isBottom(isBottom) {
      this.additionalLoading = true

      if (isBottom) {
        if (
          // this.selectedCh['chCategory'] === 'inbox'
          this.chkChPublic &&
          this.chkChPublic['isPublic']
        ) {
          this.page += 1
          this.getInboxMtInfo()
        } else if (this.$route.name === 'Assigned') {
          if (this.mtIdList && this.mtIdList.length > 0) this.getAssignedMtInfo()
        } else if (this.$route.name === 'Channel' && this.meetingList && this.meetingList.length > 0) {
          this.page += 1
          this.getChannelMtList()
        }
      }
    },
  },
  methods: {
    headerWidth() {
      let containerList = document.querySelector('.list-container')
      let containerList2 = document.querySelector('.empty-desc-box')
      let wrapHeader = document.getElementsByClassName('container-channel-header')[0]
      let wrapHeader2 = document.getElementsByClassName('container-template-header')[0]
      let wrapSkeletonHeader = document.getElementsByClassName('skeleton-header')

      if (wrapHeader) {
        if (containerList && containerList.children.length) {
          if (matchMedia('screen and (min-width: 600px)').matches) {
            wrapHeader.style.width = containerList.clientWidth - ((containerList.clientWidth % 275) + 24) + 'px'
            wrapHeader.style.maxWidth = '100%'
          } else {
            wrapHeader.style.width = containerList.clientWidth + 'px'
            wrapHeader.style.maxWidth = '100%'
          }
        }
        if (containerList2 && window.innerWidth >= 960) {
          wrapHeader.style.width = containerList2.clientWidth + 'px'
          wrapHeader.style.maxWidth = '100%'
        }
      }
      if (wrapHeader2) {
        if (containerList && containerList.children.length) {
          if (matchMedia('screen and (min-width: 600px)').matches) {
            wrapHeader2.style.width = containerList.clientWidth - ((containerList.clientWidth % 275) + 24) + 'px'
            wrapHeader2.style.maxWidth = '100%'
          } else {
            wrapHeader2.style.width = containerList.clientWidth + 'px'
            wrapHeader2.style.maxWidth = '100%'
          }
        }
        if (containerList2 && window.innerWidth >= 960) {
          wrapHeader2.style.width = containerList2.clientWidth + 'px'
          wrapHeader2.style.maxWidth = '100%'
        }
      }

      if (wrapSkeletonHeader) {
        for (let i = 0; i < wrapSkeletonHeader.length; i++) {
          if (containerList) {
            if (matchMedia('screen and (min-width: 600px)').matches) {
              wrapSkeletonHeader[i].style.width =
                containerList.clientWidth - ((containerList.clientWidth % 275) + 24) + 'px'
              wrapSkeletonHeader[i].style.maxWidth = '100%'
            } else {
              wrapSkeletonHeader[i].style.width = containerList.clientWidth + 'px'
              wrapSkeletonHeader[i].style.maxWidth = '100%'
            }
          }
          if (containerList2 && window.innerWidth >= 960) {
            wrapSkeletonHeader[i].style.width = containerList2.clientWidth + 'px'
            wrapSkeletonHeader[i].style.maxWidth = '100%'
          }
        }
      }
    },
    getMtList() {
      if (this.$route.name === 'Assigned') {
        this.getAssignedMtIdList()
      } else if (this.chkChPublic && this.chkChPublic['isPublic']) {
        this.getInboxMtInfo()
      } else if (this.$route.name === 'Channel') {
        this.getChannelMtList()
      } else {
        this.$router
          .replace({
            path: '/no-access/channel',
            query: {},
          })
          .catch(() => {})
      }
      // else if (
      //   this.selectedCh['chCategory'] === 'inbox'
      //   // (this.$route.name === 'Channel' && this.$store.getters.chkChPublic)
      // )
      //   this.getInboxMtInfo()
      // else if (this.$route.name === 'Channel' && this.isChListLoaded) this.getChannelMtList()
    },
    async moveRoute(chList) {
      let channel = chList['private'].find((channel) => channel.chCategory === 'my')
      await this.$router
        .replace({
          name: 'Channel',
          params: {
            wsDomain: this.selectedWsInfo['wsDomain'],
            chId: channel && channel['chId'] ? channel['chId'].replace('CH:', '') : 'my',
          },
        })
        .catch(() => {})
    },
    closeGuestIn() {
      this.guestInVisible = false
      if (this.userInfo && this.userInfo !== null) {
        this.startMeeting()
      }
    },
    bottomCheck() {
      this.isBottom = this.bottomVisible()
    },
    async getInboxMtInfo() {
      this.isEmpty = false
      // if (this.chList['private'] && this.chList['workspace'] && this.chList['inbox']) {
      //   let channel = [...this.chList['private'], ...this.chList['workspace'], ...this.chList['inbox']].filter((ch) => {
      //     return ch['chId'].replace('CH:', '') === this.$route.params['chId']
      //   })
      //   if (channel.length === 0) {
      //     notify(this, 'Error', this.$t('chNotExist'), 'error')
      //     return
      //   }
      // }
      let toCompareChId = this.$route.params['chId']
      let toApplyChId
      try {
        if (!this.isFinish && !this.isMtLoading) {
          this.isMeetingListLoading = true
          if (this.page === 1) this.meetingList = []
          toCompareChId = this.$route.params['chId']
          let result = await getPublicInboxList(
            this,
            this.$route.params['wsDomain'],
            // this.selectedWsInfo['wsId'],
            this.$route.params['chId'],
            this.userInfo ? this.userInfo.userId : null,
            this.page
          )
          toApplyChId = this.$route.params['chId']

          // 이전 채널리스트가 반영되지 않게 채널 변경되었을 경우를 체크한다.
          if (toCompareChId === toApplyChId) {
            if (this.page === 1) this.meetingList = result
            else this.meetingList = [...this.meetingList, ...result]
            if (result.length < this.pageLimit) this.isFinish = true
            this.isEmpty = this.meetingList.length === 0
            this.isMeetingListLoading = false
          }
        }
      } catch (error) {
        if (error.response && error.response.data === 'noPermission') {
          await this.$router
            .replace({
              path: '/no-access/channel',
              query: {},
            })
            .catch(() => {})
        } else {
          // notify(this, 'Error', this.$t('chMtLoadFailed'), 'error')
          const content = {
            component: Toast,
            props: {
              msg: this.$t('chMtLoadFailed'),
              // submsg: '',
            },
          }
          this.$toast.error(content)
        }
      } finally {
        // this.isMeetingListLoaded = true
        if (toCompareChId === toApplyChId) {
          this.additionalLoading = false
        }

        // this.$nextTick(() => {
        //   this.bottomCheck()
        // })
      }
    },
    async getAssignedMtIdList() {
      this.isEmpty = false
      try {
        this.index = 0
        this.isFinish = false
        this.meetingList = []
        this.mtIdList = []

        // if (this.assignedInfo === null) await this.$store.dispatch('getAssignedCnt', this.selectedWsInfo['wsId'])

        this.mtIdList = this.assignedInfo['mtIds']

        this.getAssignedMtInfo()

        this.$store.dispatch('getAssignedCnt', this.selectedWsInfo['wsId'])
        // this.$store.dispatch('getChannelUpdate', {
        //   wsId: this.selectedWsInfo['wsId'],
        //   chId: this.selectedCh['chId'].includes('CH:') ? this.selectedCh['chId'] : `CH:${this.selectedCh['chId']}`,
        //   chType: this.selectedCh['chType'],
        //   chCategory: this.selectedCh['chCategory'],
        // })
      } catch (error) {
        console.log(error)
      }
    },
    async getAssignedMtInfo() {
      try {
        let mtIds = []
        let count = this.index + this.pageLimit
        if (!this.mtIdList || this.mtIdList.length === 0 || this.index >= this.mtIdList.length) {
          this.isFinish = true
          if (!this.mtIdList || this.mtIdList.length === 0) this.isEmpty = true
          return
        } else {
          mtIds = this.mtIdList.slice(this.index, count)
        }
        this.index = count

        if (!this.isFinish && mtIds.length > 0) {
          this.isMeetingListLoading = true
          let result = await getMtInfo(this, this.selectedWsInfo.wsId, mtIds, this.userInfo.userId, false)
          if (this.$route.name === 'Assigned') this.meetingList = this.meetingList.concat(result)
        }
        if (this.bottomVisible() && !this.isFinish) this.getAssignedMtInfo()
        // this.isMeetingListLoading = false
      } catch (error) {
        console.log(error)
      } finally {
        // this.isMeetingListLoaded = true
        this.isMeetingListLoading = false
        this.additionalLoading = false
        this.isEmpty = !this.meetingList || this.meetingList.length <= 0

        // this.$nextTick(() => {
        //   this.bottomCheck()
        // })
      }
    },
    async getChannelMtList() {
      this.isEmpty = false

      let channel = [...this.chList['private'], ...this.chList['workspace'], ...this.chList['inbox']].filter((ch) => {
        return ch['chId'].replace('CH:', '') === this.$route.params['chId']
      })
      if (channel.length === 0) {
        // notify(this, 'Error', this.$t('chNotExist'), 'error')
        return
      }
      let toCompareChId = this.$route.params['chId']
      let toApplyChId

      try {
        if (!this.isFinish && !this.isMtLoading) {
          this.isMeetingListLoading = true
          if (this.page === 1) this.meetingList = []
          toCompareChId = this.$route.params['chId']
          let result = await getChannelMt(
            this,
            this.selectedWsInfo['wsId'],
            this.$route.params['chId'],
            channel[0]['chCategory'],
            this.page
          )

          toApplyChId = this.$route.params['chId']

          // 이전 채널리스트가 반영되지 않게 채널 변경되었을 경우를 체크한다.
          if (toCompareChId === toApplyChId) {
            if (this.page === 1) this.meetingList = result
            else this.meetingList = [...this.meetingList, ...result]
            if (result.length < this.pageLimit) this.isFinish = true
            this.isEmpty = this.meetingList.length === 0
            this.isMeetingListLoading = false
          }
        }
      } catch (error) {
        console.log('chMtLoadFailed : ', error)
        // notify(this, 'Error', this.$t('chMtLoadFailed'), 'error')

        const content = {
          component: Toast,
          props: {
            msg: this.$t('chMtLoadFailed'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
      } finally {
        if (toCompareChId === toApplyChId) {
          this.additionalLoading = false
        }
        // this.isMeetingListLoaded = true
        // this.$nextTick(() => {
        //   this.bottomCheck()
        // })
      }
    },
    bottomVisible() {
      if (
        document.scrollingElement.scrollTop > 0 &&
        document.scrollingElement.scrollTop + 1 >=
          document.scrollingElement.scrollHeight - document.scrollingElement.offsetHeight
      ) {
        return true
      } else if (
        this.$route.name !== 'Assigned' &&
        document.scrollingElement.scrollTop == 0 &&
        document.querySelector('html').scrollHeight <= document.querySelector('html').offsetHeight
      ) {
        return true
      } else {
        return false
      }

      // const scrollY = window.scrollY
      // const visible = document.documentElement.clientHeight
      // const pageHeight = document.documentElement.scrollHeight
      // const bottomOfPage = visible + scrollY >= pageHeight
      // return bottomOfPage || pageHeight < visible
    },
    close() {
      this.dialogFormVisible = false
    },
    async startMeeting(type) {
      if (!this.userInfo) {
        this.guestInVisible = true
      } else {
        this.isStartMeetingLoading = true
        this.startMeetingEvent = type

        let templateInfo
        let meetingTitle = ''

        if (type && typeof type === 'string' && type !== 'custom') {
          templateInfo = value.defaultTemplate.find((template) => template['type'] === type)
          meetingTitle = templateInfo['mtTitle']
        } else if (type && typeof type === 'string' && type === 'custom') {
          // Todo: custom template 을 조회해서 넣어주는 작업 추가해줘야함.
        }
        // type 이 없는 일반 미팅 생성
        else {
          // meetingTitle =
          //   this.userName.toLowerCase().charAt(this.userName.length - 1) === 's'
          //     ? `${this.userName}' New Meeting`
          //     : `${this.userName}'s New Meeting`
          meetingTitle = ''
        }

        //
        // if (this.$store.getters.chkMtPublic) {
        //   this.$store.dispatch('chkMtPublic', true)
        //   this.$store.getters.chkMtPublic
        // }
        try {
          let result = await setCreateMt(
            this,
            this.selectedCh && this.selectedCh['wsId'] ? this.selectedCh['wsId'] : this.selectedWsInfo.wsId,
            meetingTitle,
            [],
            'topic',
            this.selectedCh['chType'],
            this.selectedCh['chId'],
            this.selectedCh['chCategory'],
            templateInfo
          )
          // Template 미팅 생성 시 클립 갯수를 업데이트 해준다.
          if (templateInfo) {
            this.$store.dispatch('setWsClipCnt', {
              wsDomain: this.$route.params['wsDomain'],
              userId: this.userInfo ? this.userInfo['userId'] : null,
            })
          }
          if (result.mtId) {
            // userFunnel 추가
            await this.checkFunnel()

            this.$store.dispatch('setFirebaseLog', {
              eventName: 'create_meeting',
              eventParam: {
                name: 'create_meeting',
              },
            })
            // 외부 접속자 로그 추가
            if (this.isInboxAccess) {
              this.$store.dispatch('setFirebaseLog', {
                eventName: 'inbox_create_meeting',
                eventParam: {
                  name: 'inbox_create_meeting',
                },
              })
            }
            this.$store.dispatch('chkMtPublic', result.mtId)
            this.$router
              .push({
                name: 'ChannelMeeting',
                params: {
                  wsDomain:
                    this.$route.params && this.$route.params['wsDomain']
                      ? this.$route.params['wsDomain']
                      : this.selectedWsInfo['wsDomain'],
                  chId: this.selectedCh['chId'].replace('CH:', ''),
                  mtId: result['mtId'],
                },
              })
              .catch(() => {})
          } else {
            throw 'result.body.mtId'
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.isStartMeetingLoading = false
          this.startMeetingEvent = null
        }
      }
    },

    // async checkFunnel() {
    //   try {
    //     const funnel = this.userInfo.funnel
    //     const funnelUpdatedAt = this.userInfo.funnelUpdatedAt
    //     const dateGap = funnelUpdatedAt && funnelUpdatedAt !== null ? Date.now() - funnelUpdatedAt : 0
    //     const isTrigger = 1000 * 60 * 60 * 24 <= dateGap
    //     if (isTrigger && funnel && funnel !== '' && funnel === 'beginner') {
    //       let result = await setUserFunnel(this, 'regular')
    //       this.$store.commit('setUserInfo', result)
    //       this.$analytics.logEvent('funnel_regular', {
    //         uid: this.userInfo.userId,
    //         createdAt: Date.now(),
    //         methodType: 'create_meeting',
    //       })
    //     }
    //   } catch (e) {
    //     console.log()
    //   }
    // },
    async setSafariUrl() {
      let title = this.selectedCh.chTitle
      let content = ''
      let imgUrl = this.selectedCh.chLogo
      let routePayload = {
        name: 'Channel',
        params: {
          wsDomain: this.$route.params['wsDomain'],
          chId: this.selectedCh && this.selectedCh['chId'] ? this.selectedCh['chId'].replace('CH:', '') : '',
        },
      }
      let linkUrl = location.origin + this.$router.resolve(routePayload).href

      let copyUrl = await getShareUrl(this, title, content, imgUrl, linkUrl)
      this.safariPath = copyUrl.shortLink
      this.safariPathWithClipId = copyUrl.shortLink
    },
    async copyUrlToClipboard() {
      let copyResult
      let safariUrl = this.clipValue ? this.safariPathWithClipId : this.safariPath
      if (this.isSafari && this.safariUrl !== null) {
        copyResult = await copy(safariUrl)
      } else {
        await this.createShareUrl()
        copyResult = await copy(this.path)
      }

      if (copyResult) {
        this.checkFunnel()
        this.$store.dispatch('setFirebaseLog', {
          eventName: 'share',
          eventParam: {
            name: 'share',
            methodType: this.clipValue ? 'clip' : 'meeting',
          },
        })
        if (!this.isMobile) {
          // notify(this, 'Success', this.$t('copiedClipboardUrl'), 'success')

          const content = {
            component: Toast,
            props: {
              msg: this.$t('copiedClipboardUrl'),
              // submsg: '',
            },
          }
          this.$toast.success(content)
        }
      } else {
        // notify(this, 'Error', this.$t('failedCopy'), 'error')

        const content = {
          component: Toast,
          props: {
            msg: this.$t('failedCopy'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
      }
    },
    async checkFunnel() {
      if (this.computedUserInfo !== null) {
        try {
          const funnel = this.computedUserInfo['funnel']
          if (!funnel || funnel === '' || funnel === 'evaluator') {
            let result = await setUserFunnel(this, 'beginner')
            this.$store.commit('setUserInfo', result)

            this.$store.dispatch('setFirebaseLog', {
              eventName: 'funnel_beginner',
              eventParam: {
                createdAt: Date.now(),
                methodType: 'share_meeting',
              },
            })
          }
        } catch (e) {
          console.log()
        }
      }
    },
    async createShareUrl() {
      let title = this.selectedCh.chTitle
      let content = ''
      let imgUrl = this.selectedCh.chLogo
      let routePayload = {
        name: 'Channel',
        params: {
          wsDomain: this.$route.params['wsDomain'],
          chId: this.selectedCh && this.selectedCh['chId'] ? this.selectedCh['chId'].replace('CH:', '') : '',
        },
      }
      let linkUrl = location.origin + this.$router.resolve(routePayload).href
      let copyUrl = await getShareUrl(this, title, content, imgUrl, linkUrl)
      this.path = copyUrl.shortLink
    },
    deleteResult(val) {
      // this.page = 1
      // this.meetingList = []
      // this.isFinish = false
      // this.isEmpty = false

      // this.getMtList()
      let index = this.meetingList.findIndex((meeting) => meeting['mtId'] === val)
      if (index > -1) {
        this.meetingList.splice(index, 1)
      }

      // if (this.$route.name === 'Assigned') this.getAssignedMtIdList()
      // else if (this.$route.name === 'Inbox' || (this.$route.name === 'Channel' && this.$store.getters.chkChPublic))
      //   this.getInboxMtInfo()
      // else if (this.$route.name === 'Channel' && this.isChListLoaded) this.getChannelMtList()

      // if (val) this.getMtIdList(this.$route.params.type)
    },
  },
}
</script>
<style scoped>
.container-inbox-title-sub,
.container-assigned-title {
  display: grid;
  grid-template-columns: repeat(auto-fill, 275px);
  justify-content: center !important;
  grid-column: 1 span;
}
.container-inbox-title-sub,
.container-assigned-title-sub {
  display: grid;
  grid-template-columns: repeat(auto-fill, 275px);
  justify-content: center !important;
  grid-column: 1 span;
}
.list-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, 275px);
}

@media (max-width: 570px) {
  .container-inbox-title-sub,
  .container-assigned-title {
    grid-template-columns: repeat(auto-fill, 95%);
  }
  .container-inbox-title-sub,
  .container-assigned-title-sub {
    grid-template-columns: repeat(auto-fill, 95%);
  }
  .list-container {
    grid-template-columns: repeat(auto-fill, 95%);
  }
  .container-card {
    min-width: 100%;
  }
}
.inbox-sub-title,
.assigned-sub-title {
  font-size: 20px;
  font-weight: 600;
  color: white;
}
.inbox-sub-desc {
  font-size: 15px;
  font-weight: 400;
  color: #96a7af;
}
@media (max-width: 959px) {
  .inbox-sub-title,
  .assigned-sub-title {
    font-size: 17px;
    margin: 5px 0;
    margin-right: 15px;
  }
  .inbox-sub-desc {
    font-size: 13px;
    font-weight: 400;
    color: #96a7af;
  }
}

.start-meeting {
  display: flex;
  width: 100%;
  height: 100%;
  color: white;
  background: transparent;
  justify-content: center;
  align-items: center;
}
.floating-menu >>> .v-btn * {
  font-size: 24px;
  letter-spacing: 0;
  text-transform: none;
  font-weight: 700;
}

.list-container >>> .v-skeleton-loader__image {
  border-radius: 10px 10px 0 0;
}
.skeleton-header >>> .v-skeleton-loader__card-heading {
  padding: 15px 20px 0 20px;
  border-radius: 10px 10px 0 0;
}
.skeleton-header >>> .v-skeleton-loader__sentences {
  margin-top: -20px;
  padding: 0 10px 0 10px;
}
.skeleton-header >>> .v-skeleton-loader__list-item-two-line {
  border-radius: 0 0 10px 10px;
}
.list-container >>> .v-skeleton-loader__list-item-avatar {
  border-radius: 0 !important;
}
.list-container >>> .v-skeleton-loader__list-item-three-line {
  border-radius: 0 0 10px 10px;
}
.container >>> .v-skeleton-loader__article {
  padding: 20px;
}
.skeleton-header >>> .v-skeleton-loader__actions {
  display: flex;
  flex-direction: row;
  padding: 20px 35px;
  text-align: left;
  overflow: hidden;
}
.skeleton-header >>> .v-skeleton-loader__button {
  display: none;
  width: 180px !important;
  height: 10px;
  border-radius: 10px !important;
}
@media (max-width: 959px) {
  .skeleton-header >>> .v-skeleton-loader__card-heading {
    padding: 5px 10px 0 10px;
    border-radius: 10px 10px 0 0;
  }
  .skeleton-header >>> .v-skeleton-loader__sentences {
    margin-top: -30px;
    margin-bottom: -30px;
    padding: 0 10px 0 10px;
  }
  .skeleton-header >>> .v-skeleton-loader__actions {
    padding: 20px 25px;
  }
  .skeleton-header >>> .v-skeleton-loader__button {
    display: none;
    width: 80px !important;
    height: 10px;
    border-radius: 5px !important;
    margin: 0 20px 0 0 !important;
  }
}
</style>
